import { create } from 'zustand';
import { ToastType } from '../components/Toast';

interface ToastItem {
  id: string;
  type: ToastType;
  message: string;
}

interface ToastState {
  toasts: ToastItem[];
  addToast: (type: ToastType, message: string) => void;
  removeToast: (id: string) => void;
  success: (message: string) => void;
  error: (message: string) => void;
  info: (message: string) => void;
  warning: (message: string) => void;
}

export const useToast = create<ToastState>((set) => ({
  toasts: [],
  addToast: (type, message) => {
    const id = Date.now().toString();
    set((state) => ({
      toasts: [...state.toasts, { id, type, message }]
    }));
  },
  removeToast: (id) => {
    set((state) => ({
      toasts: state.toasts.filter((toast) => toast.id !== id)
    }));
  },
  success: (message) => {
    const id = Date.now().toString();
    set((state) => ({
      toasts: [...state.toasts, { id, type: 'success', message }]
    }));
  },
  error: (message) => {
    const id = Date.now().toString();
    set((state) => ({
      toasts: [...state.toasts, { id, type: 'error', message }]
    }));
  },
  info: (message) => {
    const id = Date.now().toString();
    set((state) => ({
      toasts: [...state.toasts, { id, type: 'info', message }]
    }));
  },
  warning: (message) => {
    const id = Date.now().toString();
    set((state) => ({
      toasts: [...state.toasts, { id, type: 'warning', message }]
    }));
  },
}));